export default __webpack_public_path__ + "static/media/bg.40c554e6.png";